export default __webpack_public_path__ + "static/reaction-devel-9037ffd4f0dc0f762d1257f2fbee8255.png";